@if (form) {
    <div class="searches-filter-container" [formGroup]="form">
        <div class="master-filter-col col-4">
            <p-button
                styleClass="filter-input-btn"
                (click)="op.toggle($event)"
                [label]="chosenPropertyLabel"
                [icon]="updateDropdownIcon(filtersOpenState.estateType)"
                [tooltip]="tooltip"
                tooltipPosition="top"
            />

            @if (hasSelection) {
                <span class="pi pi-times clear-button" (click)="clearEstateTypesSelection()"></span>
            }
            <p-overlayPanel #op (onShow)="onFilterEstateTypeShow()" (onHide)="onFilterEstateTypeHide()">
                <app-cascade-selection
                    #cascadeSelection
                    [isFilterOpen]="filtersOpenState.estateType"
                    firstLevelTitle="Тип имот"
                    (propertySelectionChange)="onPropertySelectionChange($event)"
                    (propertyDeselectionChange)="onPropertyDeselectionChange($event)"
                />
            </p-overlayPanel>
        </div>
        <div class="master-filter-col col-2" #filterButton>
            <p-button
                styleClass="filter-input-btn"
                (click)="op2.toggle($event)"
                [label]="chosenPriceLabel"
                [icon]="updateDropdownIcon(filtersOpenState.price)"
            />
            @if (chosenPriceLabel != 'Цена') {
                <span class="pi pi-times clear-button" (click)="clearSelection(rangeSlider1, rangeSlider2)"></span>
            }
            <p-overlayPanel styleClass="custom-overlay-panel" #op2 (onShow)="onFilterPriceShow()" (onHide)="onFilterPriceHide()">
                <app-range-slider
                    #rangeSlider1
                    [title]="'filterPrice' | localize"
                    class="filter-container-group"
                    [stepInput]="5000"
                    [valueMin]="0"
                    [valueMax]="2000000"
                    suffix=" €"
                    type="price"
                    (onSubmitForm)="handleMoneyFrom($event)"
                    [valueFrom]="form.get('moneyFrom').value"
                    [valueTo]="form.get('moneyTo').value"
                />
                <app-range-slider
                    #rangeSlider2
                    [title]="'filterPriceSquare' | localize"
                    class="filter-container-group"
                    [stepInput]="100"
                    [valueMin]="0"
                    [valueMax]="10000"
                    suffix=" €"
                    type="priceSquare"
                    (onSubmitForm)="handlePricePerSquareMetresFrom($event)"
                    [valueFrom]="form.get('squareMetrePriceFrom').value"
                    [valueTo]="form.get('squareMetrePriceTo').value"
                />
            </p-overlayPanel>
        </div>
        <div class="master-filter-col col-2">
            <p-button
                styleClass="filter-input-btn"
                (click)="op3.toggle($event)"
                [label]="chosenAreaLabel"
                [icon]="updateDropdownIcon(filtersOpenState.area)"
            />
            @if (chosenAreaLabel != 'Площ (кв/м.)') {
                <span class="pi pi-times clear-button" (click)="clearSelection(rangeSlider3)"></span>
            }

            <p-overlayPanel #op3 (onShow)="onFilterAreaShow()" (onHide)="onFilterAreaHide()" styleClass="custom-overlay-panel">
                <app-range-slider
                    #rangeSlider3
                    [title]="'Area' | localize"
                    [defaultAreaTitle]="'Area' | localize"
                    class="filter-container-group"
                    type="area"
                    [stepInput]="100"
                    [valueMin]="0"
                    [valueMax]="5000"
                    [suffix]="'squareMeter' | localize"
                    (onSubmitForm)="handleAreaChanges($event)"
                    [valueFrom]="form.get('areaFrom').value"
                    [valueTo]="form.get('areaTo').value"
                ></app-range-slider>
            </p-overlayPanel>
        </div>
        <!--Date-->
        <div class="master-filter-col col-2">
            <app-datepicker
                [showClear]="false"
                [selectionMode]="'range'"
                placeholder="{{ 'Date' | localize }}"
                formControlName="period"
                [customClass]="'period'"
            ></app-datepicker>
        </div>

        <div class="master-filter-col col-2">
            <p-dropdown
                (onShow)="onFilterOwnershipShow()"
                (onHide)="onFilterOwnershipHide()"
                [options]="ownerships"
                [(ngModel)]="selectedOwnership"
                optionLabel="name"
                [dropdownIcon]="updateDropdownIcon(filtersOpenState.ownership)"
                (onChange)="changeOwnership($event.value)"
            >
                <ng-template let-ownership pTemplate="item">
                    <div class="dropdown-option">
                        <app-svg-icon [icon]="'dot-icon'" size="small" [color]="ownership.color" />
                        <span>{{ ownership.name }}</span>
                    </div>
                </ng-template>
                <ng-template let-ownership pTemplate="selectedItem">
                    <div class="dropdown-option">
                        <app-svg-icon [icon]="'dot-icon'" size="small" [color]="ownership.color" />
                        <span>{{ ownership?.name }}</span>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>

        <div class="master-filter-col" [ngClass]="form.get('hasSource')?.value ? 'col-4' : 'col-1'">
            @if (selectedRegions.length > 0) {
                <div class="chips-container">
                    @for (region of selectedRegions; track region) {
                        <p-chip [label]="region.label" [removable]="true" (onRemove)="removeRegion(region, $event)"></p-chip>
                    }
                </div>
            }

            <div class="filter-input-btn custom-filter-input" (click)="op8.toggle($event)">
                {{ chosenLocationLabel }}

                @if (selectedRegions.length > 0) {
                    <span class="pi pi-times clear-button" (click)="clearSelectionLocation()"></span>
                }

                <div class="custom-icon">
                    <span
                        data-pc-section="icon"
                        class="p-button-icon p-button-icon-left ng-star-inserted pi pi-chevron-down rotate-icon"
                    ></span>
                </div>

                <p-overlayPanel #op8 (onShow)="onFilterLocationShow()" (onHide)="onFilterLocationHide()" [styleClass]="'overlay-map-panel'">
                    <app-cascade-selection-location
                        #appCascadeLocation
                        [options]="locationOptions"
                        [isFilterOpen]="filtersOpenState.location"
                        [selectedRegions]="selectedRegions"
                        thirdLevelTitle="Райони"
                        (selectionChange)="handleFilterChange($event)"
                        (regionsChange)="updateSelectedRegions($event)"
                        (locationChange)="onLocationChange($event)"
                    ></app-cascade-selection-location>

                    <!--                map-->
                    <div class="map-container">
                        <app-google-map
                            [height]="'440px'"
                            [width]="'100%'"
                            [center]="center"
                            [zoom]="zoom"
                            [options]="mapOptions"
                            [markers]="markers"
                            [polygons]="polygons"
                            [polygonModels]="polygonModels"
                            (mapInitialized)="onMapInitialized($event)"
                            (polygonClick)="onPolygonClick($event)"
                        />
                    </div>
                </p-overlayPanel>
            </div>
        </div>

        <!--    Source-->
        <div class="master-filter-col" [ngClass]="form.get('hasSource')?.value ? 'col-2' : 'col-4'">
            <p-dropdown
                (onShow)="onFilterSourceShow()"
                (onHide)="onFilterSourceHide()"
                [options]="sources"
                [showClear]="true"
                formControlName="source"
                placeholder="Източници"
                [group]="true"
                (onChange)="onSourceChange($event)"
                [dropdownIcon]="updateDropdownIcon(filtersOpenState.source)"
            >
                <ng-template let-group pTemplate="group">
                    <div class="flex align-items-center">
                        <span>{{ group.label }}</span>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>

        <!--    Source-detail-->
        @if (form.get('hasSource')?.value === true) {
            <div class="master-filter-col col-4">
                <p-dropdown
                    (onShow)="onFilterSourceDetailShow()"
                    (onHide)="onFilterSourceDetailHide()"
                    [options]="sourceDetail"
                    formControlName="sourceDetail"
                    optionLabel="name"
                    placeholder="Източник-детайл"
                    [dropdownIcon]="updateDropdownIcon(filtersOpenState.hasSource)"
                >
                    <ng-template let-item pTemplate="item">
                        <div class="dropdown-option">
                            <span>{{ item.name }}</span>
                        </div>
                    </ng-template>
                    <ng-template let-item pTemplate="selectedItem">
                        <div class="dropdown-option">
                            <span>{{ item?.name }}</span>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
        }

        <div class="master-filter-col col-2 filterResultsBtn-wrapper">
            <app-button
                [text]="'ShowResults' | localize"
                class="filterResultsBtn"
                [fullHeight]="true"
                [fullWidth]="true"
                (click)="onSubmit()"
            ></app-button>
        </div>

        <!--Advanced filters------------------------------->
        <div class="contacts-filter-col advanced-filters">
            <div class="flex-alignment">
                <p-button
                    styleClass="filter-input-btn"
                    (click)="toggleAdvancedFilters()"
                    [label]="'AdvancedFilters' | localize"
                    class="advanced-toggle"
                    [icon]="updateAdvancedFiltersDropdownIcon(filtersOpenState.advancedFilters)"
                />
                <span class="filter-counter">{{ loadedResultsCount }}</span>
            </div>
            <div class="flex-alignment clear-all" (click)="clearAll()">
                {{ 'ClearFilters' | localize }}
                <i class="pi pi-times cursor-pointer ng-star-inserted"></i>
            </div>
        </div>
        @if (filtersOpenState.advancedFilters) {
            <div class="advanced-filters-container">
                <app-advanced-filters
                    [ShowSearchesFilters]="ShowSearchesFilters"
                    [ShowApartmentFilters]="ShowApartmentFilters"
                    (trueValuesChange)="updateLoadedResultsCount($event)"
                    (allValuesCleared)="handleAllValuesCleared()"
                ></app-advanced-filters>
            </div>
        }
    </div>
}
